module.exports = __webpack_public_path__ + "assets/img/Infographics4.036b4b87.png";